/* =============================================================================
   LOOMA — entry controller (spec §8). Single classic deferred bundle (Shopify
   has no build step). Vanilla JS only, custom-element controllers appended per
   phase. No console output in shipped code.
   ========================================================================== */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* <looma-reveal> — IntersectionObserver stagger reveals (60ms siblings) */
  if (!customElements.get('looma-reveal')) {
    customElements.define('looma-reveal', class extends HTMLElement {
      connectedCallback() {
        var targets = this.hasAttribute('data-reveal-root')
          ? this.querySelectorAll('.reveal')
          : (this.classList.contains('reveal') ? [this] : this.querySelectorAll('.reveal'));
        if (prefersReduced || !('IntersectionObserver' in window)) {
          targets.forEach(function (el) { el.classList.add('is-in'); });
          return;
        }
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var el = entry.target;
            var sibs = Array.prototype.slice.call(el.parentNode ? el.parentNode.querySelectorAll(':scope > .reveal') : [el]);
            var i = sibs.indexOf(el);
            setTimeout(function () { el.classList.add('is-in'); }, (i > -1 ? i : 0) * 60);
            io.unobserve(el);
          });
        }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 });
        targets.forEach(function (el) { io.observe(el); });
      }
    });
  }

  /* <looma-marquee> — pause on hover, reduced-motion respect (CSS-driven) */
  if (!customElements.get('looma-marquee')) {
    customElements.define('looma-marquee', class extends HTMLElement {});
  }

  function cartAdd(body) {
    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function refreshBubble() {
    fetch('?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (d) {
      var el = document.getElementById('cart-icon-bubble'); if (!el || !d['cart-icon-bubble']) return;
      var doc = new DOMParser().parseFromString(d['cart-icon-bubble'], 'text/html');
      var src = doc.querySelector('#cart-icon-bubble') || doc.body; el.innerHTML = src.innerHTML;
    }).catch(function () {});
  }
  function afterAdd() {
    refreshBubble();
    window.Looma && window.Looma.emit('looma:cart:updated', {});
    var d = document.querySelector('looma-cart-drawer');
    if (d && d.open) { d.refresh ? d.refresh().then(function () { d.open(); }) : d.open(); }
  }

  /* <looma-hero> — auto-advance carousel */
  if (!customElements.get('looma-hero')) {
    customElements.define('looma-hero', class extends HTMLElement {
      connectedCallback() {
        this.slides = [].slice.call(this.querySelectorAll('[data-hero-slide]'));
        this.dots = [].slice.call(this.querySelectorAll('[data-hero-dot]'));
        if (this.slides.length < 2) return;
        this.i = 0; var self = this;
        var p = this.querySelector('[data-hero-prev]'), n = this.querySelector('[data-hero-next]');
        if (p) p.addEventListener('click', function () { self.go(self.i - 1); self.rest(); });
        if (n) n.addEventListener('click', function () { self.go(self.i + 1); self.rest(); });
        this.dots.forEach(function (d) { d.addEventListener('click', function () { self.go(+d.getAttribute('data-hero-dot')); self.rest(); }); });
        this.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { self.go(self.i - 1); self.rest(); } if (e.key === 'ArrowRight') { self.go(self.i + 1); self.rest(); } });
        this.addEventListener('mouseenter', function () { self.stop(); });
        this.addEventListener('mouseleave', function () { self.start(); });
        document.addEventListener('visibilitychange', function () { document.hidden ? self.stop() : self.start(); });
        if (!prefersReduced && this.getAttribute('data-autoplay') !== 'false') this.start();
      }
      go(n) { var L = this.slides.length; this.i = (n + L) % L;
        this.slides.forEach((s, k) => { var on = k === this.i; s.classList.toggle('is-active', on); s.setAttribute('aria-hidden', on ? 'false' : 'true'); });
        this.dots.forEach((d, k) => { var on = k === this.i; d.classList.toggle('is-active', on); d.setAttribute('aria-selected', on ? 'true' : 'false'); }); }
      start() { if (prefersReduced) return; this.stop(); var s = this; this.t = setInterval(function () { s.go(s.i + 1); }, 5500); }
      stop() { clearInterval(this.t); }
      rest() { this.stop(); this.start(); }
      disconnectedCallback() { this.stop(); }
    });
  }

  /* <looma-colorway> — colourway hero: swatch picker + auto-advance ring.
     Same go/start/stop/rest shape as <looma-hero>, plus ghost label, counter
     and a CSS progress ring restarted on each change. */
  if (!customElements.get('looma-colorway')) {
    customElements.define('looma-colorway', class extends HTMLElement {
      connectedCallback() {
        this.shots = [].slice.call(this.querySelectorAll('[data-cw-shot]'));
        this.swatches = [].slice.call(this.querySelectorAll('[data-cw-swatch]'));
        this.ghosts = [].slice.call(this.querySelectorAll('[data-cw-ghost]'));
        this.cta = this.querySelector('[data-cw-cta]');
        this.cur = this.querySelector('[data-cw-current]');
        this.ring = this.querySelector('[data-cw-ring]');
        this.toggleBtn = this.querySelector('[data-cw-toggle]');
        this.live = this.querySelector('[data-cw-live]');
        this.i = 0; this.paused = false;
        var self = this;
        this.dur = parseInt(this.getAttribute('data-duration'), 10) || 6000;
        this.style.setProperty('--cw-dur', this.dur + 'ms');
        if (this.shots.length < 2) return;

        this.swatches.forEach(function (b, k) {
          b.addEventListener('click', function () { self.go(k); self.rest(); });
        });
        this.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          self.go(self.i + (e.key === 'ArrowRight' ? 1 : -1));
          self.rest();
          var a = self.swatches[self.i]; if (a) a.focus();
        });
        if (this.toggleBtn) this.toggleBtn.addEventListener('click', function () {
          self.paused = !self.paused;
          self.classList.toggle('is-paused', self.paused);
          self.toggleBtn.setAttribute('aria-pressed', self.paused ? 'true' : 'false');
          self.paused ? self.stop() : self.start();
        });
        this.addEventListener('mouseenter', function () { self.stop(); });
        this.addEventListener('mouseleave', function () { if (!self.paused) self.start(); });
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) { self.stop(); } else if (!self.paused) { self.start(); }
        });
        this.go(0);
        if (!prefersReduced && this.getAttribute('data-autoplay') !== 'false') this.start();
      }
      go(n) {
        var L = this.shots.length, self = this;
        this.i = (n + L) % L;
        this.shots.forEach(function (s, k) {
          var on = k === self.i;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        this.ghosts.forEach(function (g, k) { g.classList.toggle('is-active', k === self.i); });
        this.swatches.forEach(function (b, k) {
          var on = k === self.i;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
        });
        var act = this.swatches[this.i];
        if (act) {
          this.style.setProperty('--cw-accent', getComputedStyle(act).getPropertyValue('--cw-dot') || '#0A0A0F');
          var u = act.getAttribute('data-url');
          if (this.cta && u) this.cta.href = u;
          if (this.live) this.live.textContent = act.getAttribute('data-label') || '';
        }
        if (this.cur) this.cur.textContent = ('0' + (this.i + 1)).slice(-2);
        if (this.ring && !prefersReduced) {
          this.ring.style.animation = 'none';
          void this.ring.getBoundingClientRect();
          this.ring.style.animation = '';
        }
      }
      start() { if (prefersReduced || this.paused) return; this.stop(); var s = this;
        this.t = setInterval(function () { s.go(s.i + 1); }, this.dur); this.classList.remove('is-stopped'); }
      stop() { clearInterval(this.t); this.classList.add('is-stopped'); }
      rest() { this.stop(); this.start(); }
      disconnectedCallback() { this.stop(); }
    });
  }

  /* <looma-wishlist> — heart toggle, localStorage looma:wishlist */
  function wl() { try { return JSON.parse(localStorage.getItem('looma:wishlist') || '[]'); } catch (e) { return []; } }
  document.addEventListener('click', function (e) {
    var h = e.target.closest('[data-wishlist]'); if (!h) return;
    e.preventDefault(); e.stopPropagation();
    var key = h.getAttribute('data-handle'), list = wl(), i = list.indexOf(key);
    if (i > -1) { list.splice(i, 1); h.classList.remove('is-active'); h.setAttribute('aria-pressed', 'false'); }
    else { list.push(key); h.classList.add('is-active'); h.setAttribute('aria-pressed', 'true'); window.Looma && window.Looma.emit('looma:wishlist:toggle', { handle: key, added: true }); }
    try { localStorage.setItem('looma:wishlist', JSON.stringify(list)); } catch (e2) {}
  });
  document.addEventListener('DOMContentLoaded', function () {
    var list = wl();
    document.querySelectorAll('[data-wishlist]').forEach(function (h) {
      if (list.indexOf(h.getAttribute('data-handle')) > -1) { h.classList.add('is-active'); h.setAttribute('aria-pressed', 'true'); }
    });
  });
  if (!customElements.get('looma-wishlist')) { customElements.define('looma-wishlist', class extends HTMLElement {}); }

  /* <looma-quick-add> — card ADD TO BAG (single variant direct, else go to PDP) */
  if (!customElements.get('looma-quick-add')) {
    customElements.define('looma-quick-add', class extends HTMLElement {
      connectedCallback() {
        var btn = this.querySelector('[data-card-add]'); if (!btn) return;
        var self = this;
        btn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var id = self.getAttribute('data-variant');
          if (!id || !window.fetch) { window.location = self.getAttribute('data-url'); return; }
          var lbl = btn.querySelector('.add-btn__label'), orig = lbl ? lbl.textContent : '';
          cartAdd({ id: id, quantity: 1 }).then(function (res) {
            if (res && res.status) { window.location = self.getAttribute('data-url'); return; }
            btn.classList.add('is-added'); if (lbl) lbl.textContent = '✓';
            setTimeout(function () { btn.classList.remove('is-added'); if (lbl) lbl.textContent = orig; }, 1400);
            afterAdd();
          }).catch(function () { window.location = self.getAttribute('data-url'); });
        });
        var reelAdd = this.querySelector('[data-reel-add]');
      }
    });
  }

  /* Reel add buttons (global; reels are <article> not custom elements) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-reel-add]'); if (!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-variant'); if (!id || !window.fetch) return;
    cartAdd({ id: id, quantity: 1 }).then(function (res) { if (!(res && res.status)) afterAdd(); }).catch(function () {});
  });
  document.addEventListener('click', function (e) {
    var pb = e.target.closest('[data-reel-play]'); if (!pb) return;
    var vid = pb.closest('[data-reel]') && pb.closest('[data-reel]').querySelector('video');
    if (vid) { vid.paused ? vid.play() : vid.pause(); }
  });

  window.Looma = window.Looma || {
    emit: function (n, d) { document.dispatchEvent(new CustomEvent(n, { detail: d || {} })); },
    on: function (n, f) { document.addEventListener(n, f); },
    reducedMotion: prefersReduced
  };
})();
